import React, {useState} from 'react';
import { useDispatch } from 'react-redux';
import { fetchStart, fetchEnd } from 'react-admin';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { sgxVersionable } from '../../libs/sgx/api/fetch';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AlertDialog from '../../libs/sgx/components/AlertDialog';


const backofficeUrl = 'backoffice';
const VersionableButton = ({data, resource}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const history = useHistory()
    const dispatch = useDispatch();

    const handleClick = () => {
        setLoading(true);
        dispatch(fetchStart()); // start the global loading indicator
        const url = `${backofficeUrl}/${resource}/${data.id}/versionar`;
        sgxVersionable(url)
            .then(() => {
                history.push(`/${resource}`);
            })
            .catch((error /* HttpError */) => {
                setError(error);
            })
            .finally(() => {
                setLoading(false);
                dispatch(fetchEnd()); // stop the global loading indicator
            });
    };

    if (error) {
        return (
            <AlertDialog dismiss={() => setError()} title="versionar.crear" message={error.message}></AlertDialog>
        );
    }

    return (
            <Button onClick={handleClick} color="primary" size="small"
                    startIcon={<FileCopyIcon />} disabled={loading}>
                Crear versión
            </Button>
    );
};

export default VersionableButton;